import { REVIEW_RESPONSE_TEMPLATES } from '../actions/types';

const INITIAL_STATE = [];

export default function reviewResponseReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case REVIEW_RESPONSE_TEMPLATES:
			return action.payload;
		default:
			return state;
	}
}
